import type { FunctionComponent } from 'react';

export const AlertRedExclamation: FunctionComponent = () => (
  <svg width="16" height="16" fill="none">
    <path
      fill="#C70A13"
      fillRule="evenodd"
      d="M2.98 14h10.04a1.333 1.333 0 0 0 1.154-2l-5.02-8.673a1.333 1.333 0 0 0-2.307 0L1.827 12c-.513.887.127 2 1.153 2ZM8 9.333a.669.669 0 0 1-.666-.666V7.333c0-.366.3-.666.666-.666.367 0 .667.3.667.666v1.334c0 .366-.3.666-.667.666ZM8.667 12H7.334v-1.333h1.333V12Z"
      clipRule="evenodd"
    />
  </svg>
);

AlertRedExclamation.displayName = 'AlertRedExclamation';
